package info.rezident.app.core

import kotlinx.browser.window

/**
 * Returns true if the app is running in a local or preview environment, including the dev server
 * opened from another device on the same Wi-Fi (192.168.x.x).
 */
fun isLocalEnvironment(): Boolean {
    val hostname = window.location.hostname
    return hostname.startsWith("192.168.") ||
        listOf("localhost", "127.", "preview").any { environment ->
            hostname.contains(environment, ignoreCase = true)
        }
}
